// Catálogo homogéneo de especialidades y subespecialidades médicas y odontológicas.
export const SPECIALTIES = [
  "Medicina General",
  "Medicina Familiar",
  "Pediatría",
  "Neonatología",
  "Medicina Interna",
  "Medicina de Urgencias",
  "Medicina Crítica / Intensivista",
  "Intensivista Pediátrico",
  "Cirugía General",
  "Cirugía Pediátrica",
  "Cirugía Plástica y Reconstructiva",
  "Cirugía Maxilofacial",
  "Neurocirugía",
  "Ginecología y Obstetricia",
  "Anestesiología",
  "Cardiología",
  "Cardiología Pediátrica",
  "Dermatología",
  "Dermatología Pediátrica",
  "Endocrinología",
  "Endocrinología Pediátrica",
  "Gastroenterología",
  "Gastroenterología Pediátrica",
  "Geriatría",
  "Hematología",
  "Infectología",
  "Infectología Pediátrica",
  "Nefrología",
  "Nefrología Pediátrica",
  "Neumología",
  "Neumología Pediátrica",
  "Neurología",
  "Neurología Pediátrica",
  "Nutrición Clínica",
  "Oftalmología",
  "Oncología",
  "Oncología Pediátrica",
  "Ortopedia y Traumatología",
  "Otorrinolaringología",
  "Psiquiatría",
  "Paidopsiquiatría",
  "Alergología e Inmunología Clínica",
  "Angiología y Cirugía Vascular",
  "Genética Médica",
  "Medicina del Deporte",
  "Medicina del Trabajo",
  "Medicina Física y Rehabilitación",
  "Radiología e Imagen",
  "Anatomía Patológica",
  "Reumatología",
  "Urología",
  "Proctología",
  "Odontología",
  "Odontopediatría",
  "Ortodoncia",
  "Endodoncia",
  "Periodoncia",
  "Prostodoncia",
  "Cirugía Oral y Maxilofacial",
  "Psicología Clínica",
  "Nutrición",
  "Otros",
];
